// TODO
// tslint:disable:max-file-line-count
import * as $ from 'jquery';
import { Moment } from 'moment';
import { findAny, findFirst } from '../../../../services/arrays';
import { CustomEvents } from '../../../../services/custom-events';
import { assetPrefix } from '../../services/app-storage';
import { $id } from '../../services/jquery-utils';

const airportStorage: {
    trip1: {
        originSelected: number | null,
        destinationSelected: number | null
    },
    trip2: {
        // Retour
        originSelected: number | null,
        destinationSelected: number | null
    }
} = {
        trip1: {
            originSelected: null,
            destinationSelected: null
        }, trip2: {
            // Retour
            originSelected: null,
            destinationSelected: null
        }
    };

let flightList1: IStopOverFlight[] = [],
    flightList2: IStopOverFlight[] = []; // Retour
let flightInput1: IFlightInput | null = null,
    flightInput2: IFlightInput | null = null; // Retour

function collapseListDone(collapse: boolean): void {
    $id('message-container').toggleClass('full-height', !collapse);
    $id('stopover-container').toggleClass('collapsed', collapse);
}

function collapseList(collapse: boolean, isReturn: boolean, animation: boolean): void {
    const suffix = isReturn ? 'Return' : '',
        $stopoverContainer = $id('stopover-container' + suffix),
        $notSelectedButtons = $stopoverContainer.find('.flight-list button:not(.selected)').parent(),
        $message = $id('stopover-message' + suffix);

    if (collapse) {
        if (animation) {
            $notSelectedButtons.slideUp();
            $message.slideUp(400, () => collapseListDone(collapse));
        } else {
            $notSelectedButtons.hide();
            $message.hide();
            collapseListDone(collapse);
        }
        $stopoverContainer.find('.flight-list button.selected').addClass('no-margin');

        CustomEvents.sendEvent('ValidateFlightNoUpdateNoReturn');
    } else {
        if (animation) {
            $notSelectedButtons.slideDown();
            $message.slideDown();
        } else {
            $notSelectedButtons.show();
            $message.show();
            $stopoverContainer.addClass('loaded');
        }

        $stopoverContainer.find('.flight-list button').removeClass('no-margin');
        collapseListDone(collapse);
    }
}

interface IStopOverAirport {
    id: number;
    iata: string;
    name: string;
}

export interface IStopOverFlight {
    id: number;
    origin: IStopOverAirport;
    destination: IStopOverAirport;
    datetime: Moment;
}

export interface IFlightInput {
    flightnum: string;
    flightDatetime: string;
}

export function clearStopoverAirports(isReturn: boolean): void {
    const suffix = isReturn ? 'Return' : '',
        $originList = $id(`stopover-origin${suffix}`).find('.flight-list'),
        $destList = $id(`stopover-destination${suffix}`).find('.flight-list');

    $id(`stopover-container${suffix}`).removeClass('non-transparent');
    $originList.empty();
    $destList.empty();

    const trip = (isReturn ? airportStorage.trip2 : airportStorage.trip1);
    trip.destinationSelected = null;
    trip.originSelected = null;
}

export function addStopoverAirport(airport: IStopOverAirport, options: number[],
    isOrigin: boolean, isReturn: boolean, selected?: boolean, unchangable?: boolean): void {
    const suffix = isReturn ? 'Return' : '',
        $originList = $id('stopover-origin' + suffix).find('.flight-list'),
        $destList = $id('stopover-destination' + suffix).find('.flight-list');

    let optionsString = '';
    options.forEach(option => {
        optionsString += option.toString() + ' ';
    });
    optionsString = optionsString.substring(0, optionsString.length - 1);

    const html: string = `<div><button class="custom-btn ${selected ? 'selected' : ''} `
        + `${unchangable ? 'unchangable' : ''}" `
        + `data-id="${airport.id}" data-options="${optionsString}">(${airport.iata}) ${airport.name}`
        + ` <img src="${assetPrefix}/images/flight/x.png" alt="Change airport"></button></div>`;

    if (isOrigin) $originList.append(html);
    else $destList.append(html);
}

export function getStopoverFlight(flightId: number, isReturn: boolean): IStopOverFlight | null {
    return findFirst(isReturn ? flightList2 : flightList1,
        x => x.id === flightId) || null;
}

export function getSelectedFlightID(isReturn: boolean): number | null {
    const suffix = isReturn ? 'Return' : '',
        originID = $id('flight-list1' + suffix).find('.selected').data('id'),
        destinationID = $id('flight-list2' + suffix).find('.selected').data('id');

    if (typeof originID === 'undefined' || typeof destinationID === 'undefined') {
        return null;
    }

    const flight = findFirst(isReturn ? flightList2 : flightList1,
        x => x.origin.id === parseInt(originID, 10) &&
            x.destination.id === parseInt(destinationID, 10));

    return flight ? flight.id : null;
}

function airportInArray(airport: IStopOverAirport, array: IStopOverAirport[]): boolean {
    return findAny(array, x => x.id === airport.id);
}

function getOptions(flightList: IStopOverFlight[], airport: IStopOverAirport, isOrigin: boolean): number[] {
    const options: number[] = [];
    flightList.forEach(flight => {
        const flightAirport = isOrigin ? flight.origin : flight.destination;
        if (flightAirport.id === airport.id) {
            const otherId = (isOrigin ? flight.destination : flight.origin).id;
            options.push(otherId);
        }
    });
    return options;
}

export function showSelectableStopover(input: IFlightInput, flightList: IStopOverFlight[], isReturn: boolean): void {
    // Initialize stopover list

    const suffix = isReturn ? 'Return' : '';

    if (isReturn && flightList !== flightList2
        || !isReturn && flightList !== flightList1) {

        if (isReturn) {
            flightList2 = flightList;
            flightInput2 = input;
        } else {
            flightList1 = flightList;
            flightInput1 = input;
        }

        $id(`stopover-message${suffix}`).show();
        clearStopoverAirports(isReturn);

        const originAirports: IStopOverAirport[] = [],
            destinationAirports: IStopOverAirport[] = [];

        flightList.forEach(flight => {
            if (!airportInArray(flight.origin, originAirports)) originAirports.push(flight.origin);
            if (!airportInArray(flight.destination, destinationAirports)) {
                destinationAirports.push(flight.destination);
            }
        });

        originAirports.forEach(airport => {
            addStopoverAirport(airport, getOptions(flightList, airport, true), true, isReturn);
        });

        destinationAirports.forEach(airport => {
            addStopoverAirport(airport, getOptions(flightList, airport, false), false, isReturn);
        });

        // Show container
        const $container = $id('stopover-container' + suffix);
        $container.hide();
        $container.addClass('loaded').addClass('non-transparent');
        $container.slideDown();
    } else {
        console.log(`Flightlist ${isReturn ? 2 : 1} has not changed`);
    }
}

export function showStaticStopover(input: IFlightInput, flight: IStopOverFlight, isReturn: boolean): void {
    if (isReturn) {
        flightList2 = [flight];
        flightInput2 = input;
    } else {
        flightList1 = [flight];
        flightInput1 = input;
    }

    clearStopoverAirports(isReturn);
    addStopoverAirport(flight.origin, [flight.destination.id], true, isReturn, true, true);
    addStopoverAirport(flight.destination, [flight.origin.id], false, isReturn, true, true);
    collapseList(true, isReturn, false);

    // Show container
    const $container = $id('stopover-container' + (isReturn ? 'Return' : ''));
    $container.hide();
    $container.addClass('loaded');
    $container.slideDown();
}

export function flightNumSelected(input: IFlightInput, isReturn: boolean): boolean {
    const flightInput = isReturn ? flightInput2 : flightInput1,
        flightList = isReturn ? flightList2 : flightList1;

    return (flightInput !== null && input.flightnum === flightInput.flightnum
        && input.flightDatetime === flightInput.flightDatetime) && flightList.length > 0;
}

export function anyFlightNumSelected(isReturn: boolean): boolean {
    return (isReturn ? flightList2 : flightList1).length > 0;
}

export function toggleStopover(isReturn: boolean, show: boolean): void {
    // Toggle visibility
    const $container = $id('stopover-container' + (isReturn ? 'Return' : '')),
        flightChosen = getSelectedFlightID(isReturn) !== null;

    if (show && flightChosen) {
        $container.slideDown();
    } else {
        $container.slideUp();
    }
}

export function clearStopover(isReturn: boolean): void {
    if (isReturn) {
        flightList2 = [];
        flightInput2 = null;
        airportStorage.trip2.originSelected = null;
        airportStorage.trip2.destinationSelected = null;
    } else {
        flightList1 = [];
        flightInput1 = null;
        airportStorage.trip1.originSelected = null;
        airportStorage.trip1.destinationSelected = null;
    }

    $id('stopover-container' + (isReturn ? 'Return' : '')).slideUp();
}

export function loadStopover(): void {
    const classes = 'selected not-selected';
    $('.flight-list').on('click', 'button:not(.disabled):not(.unchangable)', function () {
        const $this = $(this);

        const listId = $this.closest('.flight-list').prop('id'),
            isOrigin = parseInt(listId.substr(listId.length - 1), 10) === 1,
            isReturn = new RegExp('Return$').test(listId),
            $otherList = $id(`flight-list${(isOrigin ? '2' : '1')}` + (isReturn ? 'Return' : ''));

        if ($this.hasClass('selected')) {
            // Deselect airport
            $this.removeClass(classes).parent().siblings().find('> button').removeClass(classes).slideDown();
            $otherList.find(`button`).removeClass('disabled');

            if (isReturn) {
                if (isOrigin) {
                    airportStorage.trip2.originSelected = null;
                } else {
                    airportStorage.trip2.destinationSelected = null;
                }
            } else {
                if (isOrigin) {
                    airportStorage.trip1.originSelected = null;
                } else {
                    airportStorage.trip1.destinationSelected = null;
                }
            }
        } else {
            // Select airport
            $this.removeClass(classes).addClass('selected')
                .parent().siblings().find('> button').removeClass(classes).addClass('not-selected').slideUp();

            const flightId = parseInt($this.data('id'), 10),
                optionsStr = $this.data('options');

            let options: number[];

            if (optionsStr.length > 1) {
                options = optionsStr.split(' ').map(Number);
            } else {
                options = [parseInt(optionsStr, 10)];
            }

            $otherList.find('button').each(function () {
                const $t = $(this);
                if ($.inArray(parseInt($t.data('id'), 10), options) >= 0) {
                    $t.removeClass('disabled');
                } else {
                    $t.addClass('disabled');
                }
            });

            if (isReturn) {
                if (isOrigin) {
                    airportStorage.trip2.originSelected = flightId;
                } else {
                    airportStorage.trip2.destinationSelected = flightId;
                }
            } else {
                if (isOrigin) {
                    airportStorage.trip1.originSelected = flightId;
                } else {
                    airportStorage.trip1.destinationSelected = flightId;
                }
            }
        }

        const collapse = isReturn ?
            (airportStorage.trip2.originSelected !== null
                && airportStorage.trip2.destinationSelected !== null)
            : (airportStorage.trip1.originSelected !== null
                && airportStorage.trip1.destinationSelected !== null);

        collapseList(collapse, false, true);
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/stopover.ts